import React from "react";
import Badge from "../../shared/badge";
import Button from "../../shared/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Blogs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="w-full bg-white pb-[63px]" id="blog">
      <div className="w-[80%] m-auto max-xxxl:w-[90%]">
        {/* Header Section */}
        <div className="flex justify-between items-end mb-[40px] max-sm:flex-col max-sm:items-start max-sm:gap-[10px]">
          <div>
            <Badge txt={t("home.blogs.title")} />
            <h2 className="leading-[70px] tracking-[-3px] max-w-[833px] font-sora">
              {t("home.blogs.subtitle")}
            </h2>
          </div>
          <Button
            text={t("home.blogs.readMore")}
            className="button btn-secondary"
            height={50}
            width={155}
            onClick={() => navigate("/blogs")}
          />
        </div>

        {/* Blog Cards */}
        <div className="flex  flex-row max-sm:flex-col max-md:gap-[20px]  gap-[40px]">
          {/* Blog Card 1 */}
          <div className="bg-white shadow-lg rounded-[25px] max-sm:max-w-[100%] overflow-hidden h-fit max-w-[650px]">
            <div className="relative z-[1]">
              <img
                src="../../assets/images/home/blogimg1.png"
                alt="Blog Image 1"
                className="w-full object-cover h-auto"
              />
              <div className="absolute bottom-0 z-[3] tex-grey left-[0]">
                <img src="../../assets/images/home/blog-date-design.png" alt="" />

                <p className="text-[#9B9B9B] text-center mt-[-32px] mr-[10%] small font-medium leading-[30px] font-manrope ">
                  {t("home.blogs.blogOne.date")}
                </p>
              </div>
            </div>

            <div className="pt-[50px] pb-[45px] px-[38px]">
              <h5 className="leading-[35px] tracking-[-0.75] font-sora">
                {t("home.blogs.blogOne.title")}
              </h5>
              <p className="mt-[17px] font-medium text-gray font-manrope">
                {t("home.blogs.blogOne.description")}
              </p>
              <span className="mt-[21px] inline-block font-medium small font-manrope text-[#9B9B9B]">
                {t("home.blogs.blogOne.author")}
              </span>
            </div>
          </div>
          {/* Blog Card 2 */}
          <div className="max-sm:max-w-[100%] bg-white mt-[32px] max-sm:mt-[0px] shadow-lg rounded-[25px] overflow-hidden h-fit max-w-[420px]">
            <div className="relative z-[1]">
              <img
                src="../../assets/images/home/blogimg2.png"
                alt="Blog Image 1"
                className="w-full object-cover h-auto"
              />
              <div className="absolute bottom-0 z-[3] tex-grey left-[0]">
                <img src="../../assets/images/home/blog-date-design.png" alt="" />

                <p className="text-[#9B9B9B] text-center mt-[-32px] mr-[10%] small font-medium leading-[30px] font-manrope ">
                  {t("home.blogs.blogTwo.date")}
                </p>
              </div>
            </div>

            <div className="pt-[50px] pb-[45px] px-[38px]">
              <h5 className="leading-[35px] tracking-[-0.75] font-sora">
                {t("home.blogs.blogTwo.title")}
              </h5>
              {/* <p className="mt-[17px] font-medium text-gray font-manrope">
                Yes, AI solutions are becoming increasingly accessible to
                businesses.
              </p> */}
              <span className="mt-[57px] inline-block font-medium small font-manrope text-[#9B9B9B]">
                {t("home.blogs.blogTwo.author")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
